'use strict';

bbw.filter.ago = function() {
    if ('undefined' == typeof moment) {
        throw new Error("moment library is not loaded");
    }
    return function(value, alwaysShowTime, valueIfEmpty) {
        if (angular.isDefined(valueIfEmpty) && (angular.isUndefined(value) || value === null || value === "")) {
            return valueIfEmpty;
        }
        var date;
        var today = moment().hour(0).minute(0).second(0);
        var yesterday = moment().hour(0).minute(0).second(0).subtract(1, 'day');
        if (angular.isNumber(value) || (angular.isString(value) && value.match(/^[0-9]+$/))) {
            date = new Date(value * 1000);
        } else {
            date = value;
        }
        var m = moment(date);
        if (m.isBefore(yesterday)) {
            return m.format('D.MM.YYYY' + (alwaysShowTime ? ' в H:mm' : ''));
        } else {
            var diff = m.isBefore(today) ? 1 : 0;
            return ['сегодня', 'вчера'][diff] + ' в ' + m.format('H:mm');
        }
    }
};
